import React from "react";

const MEMBERS = [
  { name: "FortisBC Trade Ally Member", src: "/img/partners/fortisbc.png", h: "h-16" },
  { name: "HPCN Home Performance Contractor Network", src: "/img/partners/hpcn.png", h: "h-20" },
  { name: "Technical Safety BC", src: "/img/partners/technical-safety-bc.png", h: "h-16" },
  { name: "TECA Thermal Environmental Comfort Association", src: "/img/partners/teca.jpeg", h: "h-20" },
];

const Partners = () => {
  return (
    <section id="partners" className="relative bg-white py-16 lg:py-20 overflow-hidden" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4">
        {/* Members at */}
        <div className="mb-14" data-testid="members-block">
          <div className="text-center mb-8">
            <div className="eyebrow justify-center inline-flex mb-3">Certifications</div>
            <h2 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-2xl sm:text-3xl">
              Members at
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
            {MEMBERS.map((m) => (
              <div
                key={m.name}
                className="flex items-center justify-center h-24 w-full grayscale-0 hover:scale-105 transition-transform"
                data-testid={`member-${m.name.split(' ')[0].toLowerCase()}`}
              >
                <img
                  src={m.src}
                  alt={m.name}
                  className={`${m.h} w-auto max-w-full object-contain`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Dealers with */}
        <div className="border-t border-[#EAEAEA] pt-14" data-testid="dealers-block">
          <div className="text-center mb-8">
            <div className="eyebrow justify-center inline-flex mb-3">Authorized Dealer</div>
            <h2 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-2xl sm:text-3xl">
              Dealers with
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center">
            {/* Left: brand logos */}
            <div className="flex flex-col items-center gap-8">
              <div className="text-center" data-testid="dealer-goodman">
                <img
                  src="/img/partners/goodman.png"
                  alt="Goodman Air Conditioning & Heating"
                  className="h-20 w-auto mx-auto mb-2"
                  loading="lazy"
                />
                <div className="text-xs font-bold tracking-wider text-[#0F0F0F] uppercase border-b-2 border-[#0F0F0F] pb-1 inline-block">
                  Air Conditioning &amp; Heating
                </div>
              </div>

              <div className="w-2/3 border-t border-[#EAEAEA]" />

              <div className="text-center" data-testid="dealer-daikin">
                <img
                  src="/img/partners/daikin.png"
                  alt="Daikin Air Conditioners"
                  className="h-16 w-auto mx-auto"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Right: product image */}
            <div className="flex justify-center" data-testid="dealer-products">
              <img
                src="/img/partners/goodman-units.webp"
                alt="Goodman HVAC units - condensers, air handlers, and furnaces"
                className="max-h-72 w-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
